import { useRef, useState } from "react";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";
import ScalableImage from "../ScalableImage/ScalableImage";

type skill = {
    id: string,
    name: string,
    color: string,
}

type task = {
    img?: string,
    text: string,
}

export type projectType = {
    name: string,
    type: string,
    skills: skill[],
    link: string,
    description: string,
    idea?:string
    tasks?: task[],
}

type ProjectProps = {
    id: number,
    scrollTop: number,
    project: projectType,
    visit: string,
    modalCategories: string[],
    showMoreButton: string,
}

const Project = (props: ProjectProps) =>{
    const [Y, setY] = useState(0.5);
    const imageRef = useRef<HTMLImageElement | null>(null);
    const projectRef = useRef<HTMLImageElement | null>(null);
    const [mouse, setMouse] = useState<{x: number, y:number}>({x: 0, y: 0});
    const [isModalOpen, setIsModalOpen] = useState(false)

    const imageMove = (e: any) =>{
        if(!isModalOpen){
            const rect = e.currentTarget?.getBoundingClientRect();
            setY(((e.clientY - rect.top) / rect.height));
        }
    }

    const getPosition = (e: any) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        setMouse({ x, y });
    };

    return(
        <div className={`project is-in-range-${(props.scrollTop / (6092 / (window.outerWidth / window.innerWidth))) > (3750 + 500 * props.id) / 6092 } blur-background`} onMouseMove={(e) =>{imageMove(e);getPosition(e)}} onMouseOut={() => {setY(0.5)}} ref={projectRef} style={{animationDelay: `${props.id * 150 + 125}ms`}}>
            <div className="project-image">
                <a href={props.project.link} target="blank">
                    <img 
                    ref={imageRef}
                    alt={`${props.project.name}-landing-page`} 
                    loading="lazy" 
                    width={600} 
                    src={`/images/projects/${props.project.name}.webp`}
                    style={{transform: `translate(0px,${Y * 10 - 5}px)`}}
                    fetchPriority="low"
                    />
                </a>
            </div>
            <div className="visit" style={{ left: `${mouse.x}px`, top: `${mouse.y}px`}}>
                {
                    props.visit.split("").map((letter,key) =>(
                        <p style={{transform:`translate(-50%,-50%)rotate(${(360 / props.visit.length) * key}deg)`}} key={key}>{letter}</p>
                    ))
                }
            </div>
            <div className="project-header">
                <div className="project-name">
                    {props.project.name}
                </div>
                <div className="project-type">
                    {props.project.type}
                </div>
            </div>
            <div className="project-skills">
                {props.project.skills.map((skill,key) =>(
                    <div className="image" style={{backgroundColor: skill.color}} key={key}>
                        <img className={skill.id} src={`${process.env.PUBLIC_URL}/images/logos/${skill.id}.webp`} alt={skill.name} loading="lazy" fetchPriority="low"/>
                    </div>
                ))}
            </div>
            <div className="project-description">{props.project.description}</div>
            <Button className="project-button" onClick={() => {setIsModalOpen(true)}}>{props.showMoreButton}</Button>
            <Modal isOpen={isModalOpen} handleClose={() => {setIsModalOpen(false)}}>
                <div className="modal-project">
                    <div className="project-header">
                        <div className="project-name">
                            {props.project.name}
                        </div>
                        <div className="project-type">
                            {props.project.type}
                        </div>
                    </div>
                    <div className="spacer">
                        <div className="spacer-text blur-background">
                            {props.modalCategories[0]}
                        </div>
                        <div className="line"/>
                    </div>
                    <div className="project-idea">
                        {props.project.idea}
                    </div>
                    <div className="spacer">
                        <div className="spacer-text blur-background">
                            {props.modalCategories[1]}
                        </div>
                        <div className="line"/>
                    </div>
                    <div className="project-skills">
                        {props.project.skills.map((skill,key) =>(
                            <div className="image" style={{backgroundColor: skill.color}} key={key}>
                                <img className={skill.id} src={`${process.env.PUBLIC_URL}/images/logos/${skill.id}.webp`} alt={skill.name} loading="lazy"/>
                            </div>
                        ))}
                    </div>
                    <div className="spacer">
                        <div className="spacer-text blur-background">
                            {props.modalCategories[2]}
                        </div>
                        <div className="line"/>
                    </div>
                    <div className="task-container">
                        {props.project.tasks?.map((task,key) =>(
                            <div className="task" key={key}>
                                <div className="task-text">{task.text.split("|").map((text,key) =>(key === 0 ? <b key={key}>{text}</b> : text))}</div>
                                {task.img && <div className="image">
                                    <ScalableImage src={`${process.env.PUBLIC_URL}/images/projects/tasks/${props.project.name.toLocaleLowerCase()}/${task.img}.webp`} alt={task.img}/>
                                </div>}
                            </div>
                        ))}   
                    </div>
                </div>
            </Modal>
        </div>
    )
}
export default Project